import { makeStyles } from '@material-ui/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  ncForm: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  ncFormItem: {
    margin: '0.5rem',
    maxWid: '8px',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    borderBottom: `1px solid ${colors.loadingGray}`,
  },
  questionsContent: {
    marginTop: '8px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 0',
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  comments: {
    width: '423px',
    justifyItems: 'flex-end',
    color: colors.gray,
  },
  title: {
    marginTop: '16px',
    color: colors.trueBlack,
  },
  radio: {
    fontSize: fonts.sizes.medium,
    letterSpacing: '0.15px',
    lineHeight: '24px',
    fontWeight: fonts.weights.medium,
    marginRight: 35,
  },
});

export default useStyles;
